import {Controller} from "stimulus";

export default class extends Controller {
    static targets = ["paymentModal"]


    tdsPayment() {
        let tdsPercentage = this.element.querySelector('[data-id= "tds-percentange"]').value || 0.0
        let subTotal = this.element.querySelector('[data-id= "sub-total-value"]').textContent.replace(/,/g, '')
        let tdsAmount = subTotal / 100 * tdsPercentage
        this.element.querySelector('[data-id= "tds-amount"]').value = tdsAmount
        this.element.querySelector('[data-id= "total-value"]').textContent = subTotal - tdsAmount

    }

    payNow() {
        let tdsAmountHiddenField = this.element.querySelector('[name="tds_amount"]')
        tdsAmountHiddenField.value = this.element.querySelector('[data-id= "tds-amount"]').value
    }

    payModal() {
        let payNow = this.element.querySelector('[id= "payment-button"]')
        let url = payNow.href
        let tdsAmount = this.element.querySelector('[data-id= "tds-amount"]')
        if (this.element.contains(this.element.querySelector('[data-id= "tds-amount"]'))) {
            url = url + "&tds_amount=" + tdsAmount
            payNow.href = url
        }
    }

//     // tdsAmount() {
//     //     let array = []
//     //     let tdsAmount = this.element.querySelector('[data-id= "tds-amount"]').value.replace(/,/g, '')
//     //     let subTotal = this.element.querySelector('[data-id= "sub-total-value"]').textContent.replace(/,/g, '')
//     //     let tdsPercent = (tdsAmount/subTotal) * 100
//     //     if (tdsPercent > 10)
//     //     {
//     //         tdsPercent = 10
//     //         array = subTotal / 100 * tdsPercent
//     //     }
//     //     debugger;
//     //     this.element.querySelector('[data-id= "tds-amount"]').value = array
//     //
//     //     // else
//     //     // {
//     //     //     this.element.querySelector('[data-id= "tds-amount"]').value
//     //     // }
//
//
//     }
// }
}
